import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { RadioButton } from '../RadioButton';
import { Typography } from '../Typography';
import styles from './RadioButtonThumbnail.module.scss';
export const RadioButtonThumbnail = /*#__PURE__*/ React.forwardRef((props, _ref)=>{
    const { className, children, bi, noBi } = props, rest = _object_without_properties(props, [
        "className",
        "children",
        "bi",
        "noBi"
    ]);
    return /*#__PURE__*/ _jsx(RadioButton, _object_spread_props(_object_spread({
        className: cn(styles.root, className)
    }, rest, noBi ? {
        noBi
    } : {
        bi
    }), {
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.radioButtonContent,
            children: typeof children === 'string' ? /*#__PURE__*/ _jsx(Typography, {
                skin: props.disabled ? 'disabled' : 'standard',
                children: children
            }) : children
        })
    }));
});
RadioButtonThumbnail.displayName = 'RadioButtonThumbnail';
